export const isEIP6963Connector = (wallet) => {
    var _a;
    return !!(!wallet.isRainbowKitConnector && ((_a = wallet.icon) === null || _a === void 0 ? void 0 : _a.startsWith('data:image')) && wallet.uid && wallet.name);
};
